module.exports = __webpack_public_path__ + "img/item_5.8f6c779a.png";